import { TierName } from '@order/graphql';
import { useSweetpassTier } from '@order/hooks';
import { useFeatureFlag } from '@order/LaunchDarkly';

export const useSweetPassOptions = () => {
  const isSweetpassEnabled = useFeatureFlag('OPS-sweetpass-enabled', {
    listenForChanges: true,
  });

  const { sweetpassTierName } = useSweetpassTier('cache-and-network');

  const isSweetpassJoinItemVisible =
    isSweetpassEnabled &&
    Boolean(sweetpassTierName) &&
    sweetpassTierName === TierName.OptedOut;

  const isSweetpassMembershipItemVisible =
    isSweetpassEnabled &&
    Boolean(sweetpassTierName) &&
    sweetpassTierName !== TierName.OptedOut;

  return { isSweetpassJoinItemVisible, isSweetpassMembershipItemVisible };
};
